var bodyInsuranceSearch = function (vehicle_id,cartype_id, carmodel_id,body_build_year, body_insurance_status, body_insurance_zero_car,
                                    body_insurance_imported, body_discount, body_car_price,Numbering_day, Numbering_month, Numbering_year,body_previous_company,
                                    body_insurance_has_unfabric, unfabric_price) {

    function padPart(value) {
        var n = parseInt(value, 10);
        if (isNaN(n)) return '';
        return n < 10 ? '0' + n : String(n);
    }

    function showFieldError($field, message) {
        var $target = $field;
        if ($field && $field.length) {
            if ($field.hasClass('select2-hidden-accessible')) {
                $target = $field.next('.select2');
            } else if ($field.next('.select2').length) {
                $target = $field.next('.select2');
            } else if ($field.next().length && !$field.is('input[type="text"], input[type="tel"], textarea')) {
                $target = $field.next();
            }
            try {
                $target.animateCss('shake');
            } catch (e) {}
            $target.addClass('body-field-error');
            setTimeout(function () {
                $target.removeClass('body-field-error');
            }, 2500);
        }
        if (typeof Swal !== 'undefined') {
            Swal.fire({
                icon: 'warning',
                title: 'توجه',
                text: message,
                confirmButtonText: 'باشه',
                confirmButtonColor: '#ED6D37'
            });
        } else {
            alert(message);
        }
        return false;
    }

    if (vehicle_id.val() == "NAN" || vehicle_id.val() == null || vehicle_id.val() == "") {
        return showFieldError(vehicle_id, 'لطفاً نوع وسیله نقلیه را انتخاب کنید.');
    }
    if (cartype_id.val() == "NAN" || cartype_id.find("option:selected").text() == "") {
        return showFieldError(cartype_id, 'لطفاً نوع خودرو را انتخاب کنید.');
    }
    if (carmodel_id.val() == "NAN" || carmodel_id.find("option:selected").text() == "") {
        return showFieldError(carmodel_id, 'لطفاً مدل خودرو را انتخاب کنید.');
    }
    if (body_build_year.val() == "NAN" || body_build_year.find("option:selected").text() == "") {
        return showFieldError(body_build_year, 'لطفاً سال ساخت را انتخاب کنید.');
    }
    if (body_car_price.val() == '') {
        return showFieldError(body_car_price, 'لطفاً قیمت روز خودرو را وارد کنید.');
    }
    if(body_insurance_status.is(':checked') && (body_previous_company.val() == "NAN" || body_previous_company.val() == null)){
        return showFieldError(body_previous_company, 'لطفاً شرکت بیمه‌گر قبلی را انتخاب کنید.');
    }
    if (body_insurance_has_unfabric.is(':checked') && (!unfabric_price.val() || unfabric_price.val() == '')) {
        return showFieldError(unfabric_price, 'لطفاً ارزش لوازم غیرفابریک را وارد کنید.');
    }

    var url_param = '';
    var vehicleid = vehicle_id.val();
    var cartypeid = cartype_id.val();
    var cartype_name = cartype_id.find("option:selected").data('value');
    var carmodelid = carmodel_id.val();
    var bodybuildyear = body_build_year.val();
    var bodyinsurancestatus = body_insurance_status.is(':checked');
    var bodyinsurancehasunfabric = body_insurance_has_unfabric.is(':checked');
    var bodyinsuranceZeroCar = body_insurance_zero_car.is(':checked');
    var bodyinsuranceImported = body_insurance_imported.is(':checked');
    if(body_discount.val() != -1){

        var bodydiscount = body_discount.val() / 12;
    }
    var Numberingday = Numbering_day.val();
    var Numberingmonth = Numbering_month.val();
    var Numberingyear = Numbering_year.val();
    var insuranceNumbering;
    if(Numberingday != 'NAN' && Numberingmonth != 'NAN' && Numberingyear != 'NAN') {
        insuranceNumbering = Numberingyear + '/' + padPart(Numberingmonth) + '/' + padPart(Numberingday);
    }
    var bodycarprice = String(body_car_price.val() || '').replace(/[^\d]/g, '');
    var bodypreviouscompany = body_previous_company.val();

    var unfabricprice = String(unfabric_price.val() || '').replace(/[^\d]/g, '');

    if (carmodelid && carmodelid != "NAN") {
        url_param += '?carModelId=' + carmodelid;
    }

    if (bodybuildyear && bodybuildyear != "NAN") {
        if (carmodelid && carmodelid != "NAN") {
            url_param += '&';
        }
        url_param += 'buildYear=' + bodybuildyear;
    }
    url_param += '&status=' + bodyinsurancestatus;

    url_param += '&price=' + bodycarprice;

    if (bodyinsurancestatus) {
        url_param += '&Discount=' + bodydiscount;
        url_param += '&previousCompany=' + bodypreviouscompany;
    }

    if(bodyinsuranceZeroCar) {
        url_param += '&zeroKmCar=1';
    }
    if(insuranceNumbering) {
        url_param += '&Numbering=' + insuranceNumbering;
    }

    if(bodyinsuranceImported) {
        url_param += '&importedCar=1';
    }
    if (vehicleid && vehicleid != "NAN") {
        url_param += '&vehicleId=' + vehicleid;
    }

    url_param += '&hasUnfabric=' + bodyinsurancehasunfabric;
    
    if(bodyinsurancehasunfabric){
        url_param += '&unfabricPrice=' + unfabricprice;

    }

    window.location = bodyInsuranceSearchUrl + '/'  + url_param;
}
$(document).ready(function () {

    $('.body_insurance_searchBtn_top').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var vehicle_id = $('#body_vehicle_type_select');
        var cartype_id = $('#body_car_type_select');
        var carmodel_id = $('#body_car_model_select');
        var body_build_year = $('#body_build_year_select');
        var body_insurance_status = $('#body_insurance_status_select');
        var body_insurance_zero_car = $('#body_insurance_zero_car');
        var body_insurance_imported = $('#body_insurance_imported');
        var body_discount = $('#body_discount_select');
        var body_car_price = $('#body_car_price_input');
        var Numbering_day = $('#body_Numbering_day_select');
        var Numbering_month = $('#body_Numbering_month_select');
        var Numbering_year = $('#body_Numbering_year_select');
        var body_previous_company = $('#body_previous_company_select');
        var body_insurance_has_unfabric = $('#body_insurance_has_unfabric_select');
        var unfabric_price = $('#unfabric_price_input');
        bodyInsuranceSearch(vehicle_id,cartype_id, carmodel_id,body_build_year, body_insurance_status, body_insurance_zero_car,
            body_insurance_imported, body_discount, body_car_price,Numbering_day, Numbering_month, Numbering_year,body_previous_company,
            body_insurance_has_unfabric, unfabric_price);
        return false;
    });

    $('.make-switch').each(function () {
        $(this).bootstrapSwitch('state', false);
    });
})

countryList($('#insurance_destination_top'));

var showElement = function (element) {

    if($(element).is(':checked')) {
        $( ".haveinsurance_select" ).show();
        $( ".haveinsurance_select" ).addClass('active');
    }else{
        $( ".haveinsurance_select" ).hide();
        $( ".haveinsurance_select" ).removeClass('active');
    }
};
$('input[name="body_insurance_status"]').bootstrapSwitch('state', true);
$('input[name="body_insurance_has_unfabric"]').bootstrapSwitch('state', false);
$('input[name="body_insurance_zero_car"]').bootstrapSwitch('state', false);
$.fn.extend(
    {
        animateCss: function (animationName) {
            var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
            this.addClass('animated ' + animationName).one(
                animationEnd, function () {
                    $(this).removeClass('animated ' + animationName);
                }
            );
        }
    }
);
